import React, { useState, useEffect } from 'react';
import './navbar.css';
import { useLocation } from "react-router-dom";
// import axios from "axios";
// import DatePicker from "react-datepicker";
// import { Button, ListGroup, Container, Row, Col, Modal, Form } from 'react-bootstrap';
import Alunno_Form_Base from "./Alunno_form_base";
// import { BrowserRouter, Route, Switch, Navigate } from 'react-router-dom';
 import { Navigate } from 'react-router-dom';



const Alunno_form_mail = () => {

     /* idroslab */
     
    const search = useLocation().search;
    const attore = new URLSearchParams(search).get('attore');
    const id = new URLSearchParams(search).get('id');
    const indice = new URLSearchParams(search).get('indice');
    const valore = new URLSearchParams(search).get('valore');

    const [show, setShow] = useState(true);

    // the alert is displayed by default
    const [show_alert, setAlert] = useState(false);

    useEffect(() => {
        console.log('+++++ USEEFFECT +++++')

        console.log('il bottone salva [ stato premuto')

           /* idroslab */
     
        setTimeout(() => {
            setAlert(false);
        }, 3000);

    }, []);



    function Mostra_alert() {
        if (show_alert) {
            return <div class="alert alert-success" role="alert">
                This is a success alert with <a href="www.google.com" class="alert-link">an example link</a>. Give it a click if you like.
            </div>
        }
        if (!show) {
            console.log('sadgsdfgdsfgsdfgdsfgds')
            /* idroslab  non ho capito che fa */
     
            return <Navigate to="/url_form_ditta_uscita_form" replace={true} />

        }
    }



    return (
        <div>
            <div>
                <p>{id} - {attore} - {indice} - {valore} </p>
                {Mostra_alert()}
            </div>

            <div>
                <Alunno_Form_Base id={id} setShow={setShow} />
            </div >


        </div>
    );
}
export default Alunno_form_mail;